const PREFIX = 'TOPIC_';

export const ADD_TOPIC = `${PREFIX}ADD_TOPIC`;
export const GET_TOPICS_REQUEST = `${PREFIX}GET_TOPICS_REQUEST`;
export const GET_TOPICS_SUCCESS = `${PREFIX}GET_TOPICS_SUCCESS`;
export const GET_TOPICS_ERROR = `${PREFIX}GET_TOPICS_ERROR`;
